
const Tips = () => {
    return (
        <div className='educative-info-section'>
            <div className='educative-container'>
                <header className='educative-header'>
                    <h1 className='educative-main-title'>Consejos para el autocuidado y bienestar</h1>
                    <p className='educative-subtitle'>Hábitos sencillos que te ayudan a sentirte mejor cada día</p>
                </header>

                <div className='educative-text-box-container educative-info-textarea' style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    <section>
                        <p>
                            Estos consejos te ayudarán a escuchar tu cuerpo, cuidarte y sentirte más cómoda durante tu ciclo. Puedes ponerlos en práctica
                            poco a poco y crear tu propia rutina de bienestar.
                        </p>
                    </section>

                    <section>
                        <h3>Consejos clave</h3>
                        <ul>
                            <li>Lleva un registro de tu ciclo para conocer mejor tu cuerpo.</li>
                            <li>Come saludable y mantente hidratada.</li>
                            <li>Descansa lo suficiente para recuperar tu energía.</li>
                            <li>Usa ropa cómoda durante el periodo.</li>
                            <li>Habla con una persona de confianza si tienes dudas o molestias.</li>
                        </ul>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Tips;